export default {
  LIST_FETCHED: 'MANAGERS_FETCHED',
  LIST_LOAD: 'MANAGERS_LOAD',
  ITEM_DETAIL: 'MANAGERS_DETAIL',
  BUTTON_LOAD: 'MANAGERS_BUTTON_LOAD',
};
